import { useRouter } from 'next/router';

import { Routes } from 'constants/routes.constants';
import { useEmbedded } from 'hooks/useEmbedded';

/**
 * Hide CMP in embeds and on the cookie policy page (currently privacy policy)
 * so the banner does not cover the policy text.
 * Consent-local helper so we do not change global `useEmbedded` semantics.
 */
export const useHideConsentUi = () => {
  const { pathname } = useRouter();
  const { isEmbedded, isLoaded } = useEmbedded();

  // TODO: replace with Routes.CookiePolicy (or dedicated path) once available.
  const isPolicyPage = pathname === Routes.PrivacyPolicy;

  return {
    isLoaded,
    shouldHide: !!isEmbedded || isPolicyPage,
  };
};
